var map = {
	"./ClientFocus.png": 86269,
	"./Cross.svg": 2506,
	"./DeleteTag.png": 37893,
	"./Ethics.png": 63076,
	"./HighQuality.png": 10513,
	"./Innovativeness.png": 36936,
	"./NoUserPhoto.png": 37826,
	"./PurposeDirectedness.png": 38713,
	"./Purposefulness.png": 23590,
	"./Responsibility.png": 32410,
	"./SelectFiles.svg": 48291,
	"./TagsListClosed.png": 60539,
	"./TagsListOpened.png": 93400,
	"./Teamwork.png": 38496,
	"./ThanksIcon.png": 67008,
	"./ThanksIcon.svg": 63446,
	"./Trust.png": 87508,
	"./Wallet.png": 82455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69465;